// src/data/vocabulary/index.js

// ✅ Importaciones con nombres consistentes
import { VocabularyGeneral } from './general'; 
import { VocabularyPhrasal } from './phrasal verbs'; 
import { VocabularyIdioms } from './idioms';
import { VocabularyMystery } from './mystery';
import { VOCABULARY_M1_U1  } from './sets/m1';
import { VOCABULARY_M2_U1  } from './sets/m2';
import { VOCABULARY_M3_U1  } from './sets/m3';
import { VOCABULARY_M4_U1  } from './sets/m4';
import { VOCABULARY_M5_U1 } from './sets/m5';
import { VOCABULARY_M6_U1 } from './sets/m6';
import { VOCABULARY_M7_U1 } from './sets/m7';
import { VOCABULARY_M8_U1 } from './sets/m8';
import { VOCABULARY_M9_U1 } from './sets/m9';
import { VOCABULARY_M10_U1 } from './sets/m10';


import surprisePool from './surprisePool.json';

const vocabularyData = {
  sets: [
    ...VOCABULARY_M1_U1, 
    ...VOCABULARY_M2_U1,
    ...VOCABULARY_M3_U1,
    ...VOCABULARY_M4_U1,
    ...VOCABULARY_M5_U1,
    ...VOCABULARY_M6_U1,
    ...VOCABULARY_M7_U1,
    ...VOCABULARY_M8_U1,
    ...VOCABULARY_M9_U1,
    ...VOCABULARY_M10_U1,
       ...VocabularyGeneral,
    ...VocabularyPhrasal,
    ...VocabularyIdioms,
    ...VocabularyMystery,
  ],
  general: [
  ],
 
  surprisePool: surprisePool
};

export default vocabularyData;